import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DangerAlertTitle, DangerMode } from "../../../../Constants/Constants";
import { DangerAlertSubTitle } from "../../../../Data/BonusUi/SweetAlert";

const DangerAlert = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "it's danger",
      text: "Something went wrong!",
      icon: "error",
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={DangerAlertTitle} span={DangerAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="danger" className="sweet-7" onClick={handleAlert}>
            {DangerMode}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DangerAlert;
